// import Swiper JS
import Swiper, { Navigation, FreeMode, Mousewheel, Controller } from 'swiper';
import Stickyfill from 'stickyfilljs';
// import Swiper styles
// import 'swiper/css';

const swiperCalendarContent = new Swiper('.swiper-calendar-content', {
  modules: [Navigation, FreeMode, Mousewheel, Controller],
  slidesPerView: "auto",
  freeMode: {
    enabled: true,
    sticky: false,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});


const swiperCalendarHeader = new Swiper('.swiper-calendar-header', {
  modules: [Navigation, FreeMode, Mousewheel, Controller],
  slidesPerView: "auto",
  freeMode: {
    enabled: true,
    sticky: false,
  },
});


swiperCalendarHeader.controller.control = swiperCalendarContent;
swiperCalendarContent.controller.control = swiperCalendarHeader;

//IE-11 fallback for position sticky
let calendarHeader = document.querySelector(".swiper-calendar-header");
let calendarHeaderTop = document.querySelector(".calendar-header-top");

addClassWhenElementIsSticky(calendarHeader, calendarHeaderTop);

function addClassWhenElementIsSticky(elem, elemTop) { 
  if (!elem) return;
  Stickyfill.add(elem);
  
  //to check when elem get's position sticky
  let observer = new IntersectionObserver(function(entries) {
    // no intersection 
    if (entries[0].intersectionRatio === 0)
      elem.classList.add("-is-sticky");
    // fully intersects 
    else if (entries[0].intersectionRatio === 1)
      elem.classList.remove("-is-sticky");
  }, {
    threshold: [0, 1]
  });

  observer.observe(elemTop);
};